import { render, staticRenderFns } from "./TraxUiAjaxDataTable.vue?vue&type=template&id=4f575612&scoped=true"
import script from "./TraxUiAjaxDataTable.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxDataTable.vue?vue&type=script&lang=js"
import style0 from "./TraxUiAjaxDataTable.vue?vue&type=style&index=0&id=4f575612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f575612",
  null
  
)

export default component.exports